import { UserRole } from '@symfa-inc/providence-verizon-types';

export const isNotOnlyReadOnlyUser = (roles: UserRole[] = []): boolean =>
  !(roles.length === 1 && roles.includes(UserRole.ReadOnly));
